export const distinctCollectionToString = (
    collection: any[],
    separator: string): string => {
      return collection ? Array.from(new Set(collection)).join(separator) : "";
}
